import { Userpilot } from 'userpilot';

let initialized = false;

export function initUserpilot(token: string) {
  if (initialized) return;
  Userpilot.initialize(token);
  initialized = true;
}

export function identifyUser({currentUser, profile}) {
  if (!initialized) return;
  Userpilot.identify(currentUser.uid, {
    name: profile?.first_name + ' ' + profile?.last_name,
    email: currentUser.email,
    company: profile?.company_name,
    companySize: profile?.company_size,
    country: profile?.country,
    industry: profile?.industry,
    occupation: profile?.occupation,
    specialization: profile?.specialization,
    userRole: currentUser?.role,
  });
}

export function disableUserpilot() {
  if (!initialized) return;
  // Clear Userpilot instance manually
  (window as any).userpilot = undefined;
  initialized = false;
}
